import { render, staticRenderFns } from "./ClaimsLightCommercial.vue?vue&type=template&id=80775fea&scoped=true&"
import script from "./ClaimsLightCommercial.vue?vue&type=script&lang=js&"
export * from "./ClaimsLightCommercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80775fea",
  null
  
)

export default component.exports